export default __webpack_public_path__ + "static/media/spark_89.445c397e.png";